import { AxiosResponse } from 'axios';
import { isRetryableError } from 'axios-retry';
import ConfiguracaoUrl from '../misc/Configuracao';
import { ISearch, Pauta, Processo } from '../modelo';
import { IPaginacao } from '../modelo/dto/Paginacao';
import { EmentaDecisao } from '../modelo/EmentaDecisao';
import { IResultadoOperacao } from '../modelo/ResultadoOperacao';
import { IUnidadePublicacao } from '../modelo/UnidadePublicacao';
import { UnidadePublicadora } from '../modelo/UnidadePublicadora';
import { UsuarioStore } from '../store';
import { EtiquetaOrigem, IEtiqueta } from './../modelo/Etiquetas';
import fetch from './AxiosAdapter';
import { IProcessoDto } from './dto/ProcessoDto';
import Configuracao
    from "@/utils/Configuracao";
import { ProcessoAssociado, ProcessoComCorreJunto } from '@/modelo/ProcessoRelacionamentos';
import { apiErroPadraoJaExibido, apresentarApiErroPadrao } from '@/utils/ApiErroPadraoUtils';


/*const mapRegra = {
    "POSSUI_MINUTA": {
        "descricao": "Processo possui determinado tipo de Minuta",
        "tipoValor": "java.lang.Integer",
        "id": "POSSUI_MINUTA"
    },
    "PROCESSO_EM_NO_FLUXO_PJE": {
        "descricao": "Processo em nó específico do Fluxo PJe",
        "tipoValor": "java.lang.String",
        "id": "PROCESSO_EM_NO_FLUXO_PJE"
    },
    "ORGAO_JULGADOR_COLEGIADO_DIFERENTE_DE": {
        "descricao": "Órgão Julgador Colegiado diferente de",
        "tipoValor": "java.util.List",
        "id": "ORGAO_JULGADOR_COLEGIADO_DIFERENTE_DE"
    },
    "VOTO_LIBERADO_PARA_PAUTA": {
        "descricao": "Voto precisa estar liberado para pauta",
        "tipoValor": "java.lang.Boolean",
        "id": "VOTO_LIBERADO_PARA_PAUTA"
    }
}*/

export class ProcessoApi {

    async buscarGabinetesOndeProcessoEstaImportado(idProcesso: number): Promise<string[]> {
        const params = new URLSearchParams({ id_processo: idProcesso.toString() });
        const result = await fetch<string[]>(
            `${ConfiguracaoUrl.urlProcessosGE}gabinetes-processo-importado?${params.toString()}`
        );
        return result.data || [];
    }

    async associarProcessoAServidor(orgao: string, cpf: string, proximoCard: number, processos: Processo[], observacao: string): Promise<IResultadoOperacao> {

        if (proximoCard === 0 || !proximoCard) {
            proximoCard = -2;
        }
        if (!observacao || observacao.trim() === '') {
            observacao = null;
        }

        if (cpf == '-1') {
            cpf = '';
        }

        const url = `${ConfiguracaoUrl.urlControlesGabineteGE}${orgao}/processos`;
        const result = await fetch<IResultadoOperacao>(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: {
                'numeroCpfResponsavelNovo': cpf,
                'processos': processos.map(proc => ({ identificadorProcesso: proc.identificadorProcesso, numeroControleGabineteAtual: proc.numeroControleGabineteAtual, numeroMinuta: proc.minutaSelecionada })),
                'numeroControleGabineteNovo': proximoCard,
                'observacao': observacao
            }
        });
        if (result.status === 500) {
            throw new Error('Erro interno do servidor.');
        } else if (result.status === 404) {
            throw new Error('Não foi possível fazer a operação');
        } else if (result.status >= 300) {
            throw new Error('Erro! não foi possivel realizar a operação');
        }
        return result.data;
    }

    async buscarPartesProcessoFiltro(): Promise<Map<string, string>> {
        const result = await fetch(ConfiguracaoUrl.urlBuscaPartesProcessoFiltro + UsuarioStore.localizacao.siglaOrgaoJulgador, { method: 'GET' });
        return result.data as Map<string, string>;
    }

    // async importarProcessos(orgaoJulgador) {

    //     let result = {} as any;
    //     try {
    //         let resultPje: any = await this.importarProcessosPjeELegado(orgaoJulgador);
    //         result.pje = resultPje.quantidadeProcessos + ' processos importados.';
    //     } catch (erro) {
    //         console.error(erro);
    //         MensagemStore.apresentarErro("Não foi possível importar processos do PJe. Entre em contato com o suporte" + erro.message);
    //         result.pje = "PJe: 0 importados";
    //     }

    //     return result;
    // }

    // async importarProcessosPjeELegado(orgaoJulgador) {

    //     let result = await fetch(ConfiguracaoUrl.urlProcessosGabineteAntigo + orgaoJulgador, {
    //         method: 'POST'
    //     });

    //     if (result.status !== 201) {
    //         let erro: any = result.data;
    //         if (!erro) {
    //             erro = {
    //                 mensagem: 'Erro Desconhecido'
    //             };
    //         } else if (result.status >= 500 && result.status <= 600) {
    //             erro = {
    //                 mensagem: 'Não foi possível se conectar ao servidor.'
    //             };
    //         }
    //         console.error(erro.mensagem);
    //         throw new Error(erro.mensagem);
    //     }

    //     return result.data;
    // }

    // async quantidadeProcessosPorResponsavel(orgaoJulgador: string, cpf: string, numeroControleGabinete: number, apenasProcessos: boolean): Promise<number> {
    //     let url = `${ConfiguracaoUrl.urlProcessosGabineteAntigo}${orgaoJulgador}?numeroCpfResponsavel=${cpf}`;
    //     url += this.seExiteRetornaString(numeroControleGabinete, '&numeroControleGabinete=' + numeroControleGabinete);
    //     url += this.seExiteRetornaString(apenasProcessos, '&apenasProcessos=' + apenasProcessos);

    //     const result = await fetch(url, { method: 'HEAD' });
    //     const quantidade = result.headers['x-total-count'];
    //     return parseInt(quantidade);
    // }

    async recuperaProcessoPorId(idProcesso) {
        let result;
        try {
            const url = ConfiguracaoUrl.urlProcessosGE + idProcesso;
            result = await fetch(url);
        } catch (error) {
            console.error(result);
            if (apresentarApiErroPadrao(error) || apiErroPadraoJaExibido(error)) {
                throw error;
            }
            throw new Error('Ocorreu um erro em sua solicitação. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.');
        }
        const processo = result.data;
        if (result.status !== 200) {
            throw new Error('Não foi possível recuperar o processo. Tente novamente.');
        }
        return processo;
    }

    async recuperaAndamentoInternoNoGabinete(idProcesso, siglaLocal) {
        let result;
        try {
            const url = ConfiguracaoUrl.urlProcessosGE + idProcesso + '/andamento-interno/?siglaLocal=' + siglaLocal
            result = await fetch(url);
        } catch (error) {
            console.error(result);
            if (apresentarApiErroPadrao(error) || apiErroPadraoJaExibido(error)) {
                throw error;
            }
            throw new Error('Ocorreu um erro em sua solicitação. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.');
        }
        const andamentoInternoGabinete = result.data;
        if (result.status !== 200) {
            throw new Error('Não foi possível recuperar o andamento interno do processo. Tente novamente.');
        }
        return andamentoInternoGabinete;
    }

    async recuperaProcessosComCorreJunto(
        idsProcessos: number[]
    ): Promise<Record<number, ProcessoComCorreJunto[]>> {
        let result;

        try {
            const url = ConfiguracaoUrl.urlProcessosGE + 'corre-junto';

            result = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: idsProcessos
            });

        } catch (error) {
            console.error(error);
            if (apresentarApiErroPadrao(error) || apiErroPadraoJaExibido(error)) {
                throw error;
            }
            throw new Error(
                'Ocorreu um erro em sua solicitação. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.'
            );
        }

        if (result.status > 300) {
            throw new Error('Não foi possível recuperar os processos com corre-junto.');
        }

        return result.data as Record<number, ProcessoComCorreJunto[]>;
    }

    async recuperaProcessosAssociados(idsProcessos: number[]): Promise<Record<number, ProcessoAssociado[]>> {
        let result;

        try {
            const url = ConfiguracaoUrl.urlProcessosGE + 'associados';

            result = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: idsProcessos
            });

        } catch (error) {
            console.error(error);
            if (apresentarApiErroPadrao(error) || apiErroPadraoJaExibido(error)) {
                throw error;
            }
            throw new Error(
                'Ocorreu um erro em sua solicitação. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.'
            );
        }

        if (result.status > 300) {
            throw new Error('Não foi possível recuperar os processos associados.');
        }

        return result.data as Record<number, ProcessoAssociado[]>;
    }

    async idProcessoPorNumero(numeroDeProcesso) {
        let result;
        try {
            const url = ConfiguracaoUrl.urlIdProcessoPorNumero + numeroDeProcesso;
            result = await fetch(url);
        } catch (error) {
            if (apresentarApiErroPadrao(error) || apiErroPadraoJaExibido(error)) {
                throw error;
            }
            console.error('Erro ao recuperar id do processo por número:', error);
            throw new Error('Ocorreu um erro em sua solicitação. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.');
        }
        const idProcesso = result.data;
        if (result.status !== 200) {
            throw new Error('Não foi possível recuperar o processo. Tente novamente.');
        }
        return idProcesso;
    }

    async devolverProcesso(processo: Processo, observacaoDevolucao: string, codMotAnd: number) {
        const processoAlerta = {
            idProcesso: processo.identificadorProcesso,
            alerta: {
                descricaoAlerta: observacaoDevolucao,
                inCriticidade: 'I'
            },
            motivoAndamento: codMotAnd
        };
        const result = await fetch(ConfiguracaoUrl.urlProcessosGE + processo.identificadorProcesso + '/devolver/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            data: processoAlerta
        });
        if (result.status > 300) {
            return result.data;
        }
        return result;

    }

    async carregarUnidadesPublicacao(idProcesso: number): Promise<IUnidadePublicacao[]> {
        const result = await fetch<Promise<IUnidadePublicacao[]>>(ConfiguracaoUrl.urlProcessosGE + idProcesso + '/unidades-publicacao')
        return result.data;
    }

    async carregarTodasUnidadesPublicacao(): Promise<UnidadePublicadora[]> {
        const result = await fetch<Promise<UnidadePublicadora[]>>(ConfiguracaoUrl.urlProcessosGE + '-1/unidades-publicacao')
        return result.data;
    }

    async atualizarConteudoDaMinutaDoProcesso(idProcesso: number, numMinuta: number | null) {
        try {
            let url = ConfiguracaoUrl.urlProcessosGE + idProcesso + '/recarregar-minuta';
            if (numMinuta != null) {
                url += '?numMinuta=' + numMinuta;
            }

            const result: any = await fetch(url, {
                method: 'POST'
            });
            return result.data;
        } catch (error) {
            console.error(error);
            if (apresentarApiErroPadrao(error) || apiErroPadraoJaExibido(error)) {
                throw error;
            }
            throw new Error('Ocorreu um erro ao tentar atualizar os dados do processo com o Pje. Por favor, tente novamente. Caso persista, comunique ao administrador do sistema.');
        }
    }

    async atualizarDadosDoProcesso(idProcesso) {
        try {
            const gabinete = UsuarioStore.gabinete;
            const url = `${ConfiguracaoUrl.urlProcessosGE}${idProcesso}/recarregar${gabinete ? `?gabinete=${encodeURIComponent(gabinete)}` : ''}`;
            const result: any = await fetch(url, {
                method: 'POST'
            });

            return result.data;
        } catch (error) {
            console.error(error);
            if (apresentarApiErroPadrao(error) || apiErroPadraoJaExibido(error)) {
                throw error;
            }
            throw new Error('Ocorreu um erro ao tentar atualizar os dados do processo com o Pje. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.');
        }
    }

    async retirarProcessoDoGe(numerosProcesso: string[], cpfResponsavel = '', localizacao = '', motivo = '') {
        const body = numerosProcesso.map(num => {
            return {
                numeroProcesso: num,
                cpfResponsavel: cpfResponsavel,
                localizacao: localizacao,
                motivo: motivo
            }
        })
        try {
            const result = await fetch(ConfiguracaoUrl.urlProcessosGE, {
                method: 'DELETE',
                body: body
            });

            if (result.status === 404) {
                throw new Error('Processo não existe.');
            } else if (result.status === 403) {
                throw new Error('Processo não pode ser retirado.');
            } else if (result.status > 300) {
                return result.data;
            }
            return result;
        } catch (error) {
            console.error(error);
            if (apresentarApiErroPadrao(error) || apiErroPadraoJaExibido(error)) {
                throw error;
            }
            throw new Error('Ocorreu um erro inesperado ao tentar retirar o processo do Gabinete Eletrônico. Tente novamente ou contate o administrador.');
        }
    }

    //MANTEM
    private async filtroRapidoIds(search: ISearch, abortSignal?: AbortSignal, silent?: boolean): Promise<number[]> {
        if (!search.paginacao) {
            search.paginacao = { pagina: 1, tamanhoPagina: 1000 } as IPaginacao;
        }
        const result: AxiosResponse<number[]> =
            await fetch(ConfiguracaoUrl.urlControlesGabineteGE + search.gabinete + '/processos/filtro-rapido/idsProcessos?isMagistrado=' + UsuarioStore.usuarioTemPapel(Configuracao.PERFIL_MAGISTRADO), {
                method: 'POST',
                data: search,
                signal: abortSignal,
                silent: silent,
                'axios-retry': {
                    retries: 3,
                    shouldResetTimeout: true,
                    retryDelay: (retryCount) => {
                        return retryCount * 1000;
                    },
                    retryCondition: isRetryableError
                },
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });

        if (result.status !== 200) {
            let erro: any = result.data;
            if (!erro) {
                erro = {
                    mensagem: 'Erro Desconhecido'
                };
            } else if (result.status >= 500 && result.status <= 600) {
                erro = {
                    mensagem: 'Não foi possível se conectar ao servidor.'
                };
            }
            console.error(erro.mensagem);
            throw new Error(erro.mensagem);
        }
        return result.data;
    }

    private async filtroRapido(search: ISearch, abortSignal?: AbortSignal, silent?: boolean): Promise<IProcessoDto[]> {
        if (!search.paginacao) {
            search.paginacao = { pagina: 1, tamanhoPagina: 1000 } as IPaginacao;
        }
        const opcoes: any = {
            method: 'POST' as const,
            data: search,
            signal: abortSignal,
            silent: silent,
            timeout: 120000,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            'axios-retry': {
                retries: 1,
                shouldResetTimeout: true,
                retryDelay: (retryCount) => {
                    return retryCount * 1000;
                },
                retryCondition: isRetryableError
            },
        };

        const tratarResultado = (result: AxiosResponse<IProcessoDto[]>) => {
            if (result.status !== 200) {
                let erro: any = result.data;
                if (!erro) {
                    erro = {
                        mensagem: 'Erro Desconhecido'
                    };
                } else if (result.status >= 500 && result.status <= 600) {
                    erro = {
                        mensagem: 'Não foi possível se conectar ao servidor.'
                    };
                }
                console.error(erro.mensagem);
                throw new Error(erro.mensagem);
            }
            return result.data;
        };

        const baseUrl = ConfiguracaoUrl.urlControlesGabineteGE + search.gabinete + '/processos/';
        const sufixo = '?isMagistrado=' + UsuarioStore.usuarioTemPapel(Configuracao.PERFIL_MAGISTRADO);

        const result = await fetch<IProcessoDto[]>(baseUrl + 'filtro-rapido2' + sufixo, opcoes);
        return tratarResultado(result);
    }

    async recuperaPorSearch(search: ISearch, abortSignal?: AbortSignal, silent?: boolean): Promise<IProcessoDto[]> {
        return this.filtroRapido(search, abortSignal, silent);
    }

    //MANTEM
    async recuperaIdsProcessosPorSearch(search: ISearch, abortSignal?: AbortSignal, silent?: boolean): Promise<number[]> {
        return this.filtroRapidoIds(search, abortSignal, silent);
    }

    seExiteRetornaString(param, string) {
        if (param) {
            return string;
        } else {
            return '';
        }
    }

    async recuperarEtiquetas(identificadorProcesso: number): Promise<IEtiqueta[]> {
        const etiquetas = await this.recuperarEtiquetasDeTodosOsProcessos([identificadorProcesso]);
        return etiquetas[identificadorProcesso];
    }

    async recuperarEtiquetasDeTodosOsProcessos(idsProcesso: number[]): Promise<IEtiqueta[][]> {
        if (idsProcesso.length) {
            const result = await fetch(ConfiguracaoUrl.urlConsultaEtiquetas, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: idsProcesso
            });
            return result.data as IEtiqueta[][];
        }
        return [];
    }

    async recuperarTriagemLivreDeProcessos(idsProcesso: number[]): Promise<string[]> { //Promise<Map<number, string>> {
        if (idsProcesso.length) {
            const result = await fetch(ConfiguracaoUrl.urlTriagemLivre, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: idsProcesso
            });
            return result.data as any;
        }
        return [];
    }

    async recuperarProcessosFavoritos(): Promise<boolean[]> {
        const result = await fetch<number[]>(ConfiguracaoUrl.urlGetFavoritos, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const favoritos = result.data;
        const arrayfavoritos = []; //retorno map<number, boolean>
        favoritos.forEach(fav => arrayfavoritos[fav] = true);
        return arrayfavoritos;
    }

    async salvarProcessosFavorito(idProcesso: number) {
        const result = await fetch(ConfiguracaoUrl.urlGetFavoritos + '/id/' + idProcesso + '/favorito',
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });
        if (result.status !== 200) {
            console.error(result.data);
            throw new Error("Erro ao salvar o favorito");
        }
    }

    async retirarProcessosFavorito(idProcesso: number) {
        const result = await fetch(ConfiguracaoUrl.urlGetFavoritos + '/id/' + idProcesso + '/favorito',
            {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });
        if (result.status !== 200) {
            console.error(result.data);
            throw new Error("Erro ao retirar o favorito");
        }
    }

    async removerEtiqueta(identificadorProcesso, numeroTag) {
        const values = {
            numero: numeroTag,
            texto: 'deletar'
        };
        return fetch(ConfiguracaoUrl.urlProcessosGE + identificadorProcesso + '/etiquetas',
            {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(values)
            });
    }

    async removerEtiquetaEmLote(idsProcessos, numeroTags) {
        const payload = idsProcessos
            .map((idProcesso, i) => numeroTags[i] != null ? { idProcesso, numeroEtiqueta: numeroTags[i] } : null)
            .filter(Boolean);

        return fetch(ConfiguracaoUrl.urlProcessosGE + 'etiquetasEmLote', {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
    }

    async adicionarEtiqueta(identificadorProcesso, tag, login, numeroTag) {
        const values = [{
            texto: tag,
            numero: numeroTag,
            cpf: login
        }];
        return fetch(ConfiguracaoUrl.urlProcessosGE + identificadorProcesso + '/etiquetas',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: values
            });
    }

    async adicionarEtiquetaEmLote(idsProcessos, etiquetas) {
        const payload = {
            idsProcessos: idsProcessos,
            etiquetas: etiquetas
        };

        return fetch(ConfiguracaoUrl.urlProcessosGE + 'etiquetasEmLote', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
    }


    async buscarImpedimentosNoProcesso(idProcesso: number) {
        const siglaOJ = UsuarioStore.gabinete;
        const url = `${ConfiguracaoUrl.urlProcessosGE}${idProcesso}/impedimentos/${siglaOJ}`;
        const result = await fetch<Array<string>>(url);
        let impedimentosFiltrado = []
        if (result.data) {
            impedimentosFiltrado = result.data.filter(imp => {
                if (imp.includes('quanto ao processo') && !imp.includes(siglaOJ)) {
                    return false;
                } else {
                    return true;
                }
            });
        }

        return impedimentosFiltrado;
    }

    async buscarImpedimentos(idsProcesso: number[]) {
        const siglaOJ = UsuarioStore.gabinete;
        const url = `${ConfiguracaoUrl.urlImpedimentos.replace('{siglaOJ}', siglaOJ)}`;
        const result = await fetch<Map<string, string[]>>(url, {
            method: 'POST',
            body: idsProcesso
        });
        if (result.data) {
            idsProcesso.forEach(id => {
                result.data[id] = result.data[id]?.filter(imp => {
                    if (imp.includes('quanto ao processo') && !imp.includes(siglaOJ)) {
                        return false;
                    } else {
                        return true;
                    }
                });
            })
        }
        return result.data;
    }

    async recuperarEmentaDecisao(idProcesso: number): Promise<EmentaDecisao> {
        const result = await fetch<EmentaDecisao>(ConfiguracaoUrl.urlRecuperarEmentaDecisao, {
            method: 'POST',
            body: [idProcesso]
        });

        return result.data;
    }

    async salvarTriagemLivre(idsProcesso: number[], textoTriagem: string) {
        const url = ConfiguracaoUrl.urlSalvarTriagem + `p=${idsProcesso.join("&p=")}`;
        return await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: { conteudo: textoTriagem }
        });
    }

    async consultaEtiquetasDaOrigem(idsProcesso: number[]): Promise<Map<number, EtiquetaOrigem[]>> {
        const url = ConfiguracaoUrl.urlEtiquetasOrigem;
        const etiquetas = await fetch<Map<number, EtiquetaOrigem[]>>(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: idsProcesso
        });
        return etiquetas.data;
    }

    async baixarInteiroTeor(idProcesso: number) {
        const inteorTeor = await fetch(ConfiguracaoUrl.urlBaixarInteiroTeor.replace('{ID_PROCESSO}', idProcesso.toString()));
        return inteorTeor.data;
    }

    async buscarUltimaInclusaoEmPauta(idsProcesso: number[]) {
        const result = await fetch<Map<number, Pauta>>(ConfiguracaoUrl.urlBuscarUltimaPauta, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: idsProcesso
        });
        return result.data;
    }

    async buscarProcessosPautasFuturas(orgaoJulgador : string) {
        const result = await fetch<IProcessoDto[]>(ConfiguracaoUrl.urlBuscarProcessosPautasFuturas.replace('{ORGAO_JULGADOR}', orgaoJulgador), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return result.data;
    }

}

export default new ProcessoApi();
